import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import * as functionalUsage from '../../functional-usage'
import type { Plugin } from '../plugin'

/**
 * Loads record warnings when record functional usage is successfully updated.
 */
export const loadForCurrentEntityOnFunctionalUsageChange = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    plugin.collection.plugins
      .lookup(functionalUsage.Plugin)
      .get()
      .actions.applyUpdates.success.observe()
      .pipe(
        rxjs.map(() =>
          feature.actions.loadForCurrentEntity.request
            .from(
              '(effect) load record warnings for current entity on functional usage change',
            )
            .create(),
        ),
      ),
)
